import React, {Component} from "react";
import { Nav, NavItem, NavLink, Progress } from "reactstrap";
import { make_request, seconds_to_clock, pad_num } from "../../Utils/Utils";
import { Modal, ModalBody } from "reactstrap";
import ReactTooltip from "react-tooltip";

function clock(seconds) {
  // multiply with 1000 for convert seconds into millieseconds
  var clock = seconds_to_clock(seconds*1000);
  var timer = pad_num(clock.minutes)+":"+pad_num(clock.seconds);
  if(clock.days > 0) {
    timer = pad_num(clock.days)+":"+pad_num(clock.hours)+":"+timer
  } else if(clock.hours > 0) {
    timer = pad_num(clock.hours)+":"+timer
  }
  return timer;
}


function clock_in_words(seconds) {
  // multiply with 1000 for convert seconds into millieseconds
  var clock = seconds_to_clock(seconds*1000);
  
  var timer = clock.minutes +" minutes and "+ clock.seconds + " seconds";
  if(clock.days > 0) {
    timer = clock.days+" days, " + clock.hours + " hours, " + timer ;
  } else if(clock.hours > 0) {
    timer = clock.hours +" hours, " + timer ;
  }
  return timer;
}

function recent_answers_loop(recent_answers) {
  return(
    <ul className="list-group headline mb-4" style={{overflow: "auto", maxHeight: "270px"}}>
      {
        (recent_answers.length > 0) && recent_answers.map((recent_answer, index) => {
          return(
            <li key={index} >
              <span className="list-group-item" style={recent_answer.includes("_level_answer") ? {color: "black"} : {background: "#141414", color: "white", padding:"0px 5px"}}> {recent_answer.replace("_level_answer", "")} </span> <hr />
            </li>

          )
        })
      }
    </ul>
  )
}

function RightSidePanel(props) {
  return (
    <div className={props.mobile ? "d-xl-none d-lg-block d-md-block d-sm-block d-block" : "col-xl-2 col-lg-12 col-md-12 col-12 d-xl-block d-lg-none d-md-none d-sm-none d-none"}>
      {
        props.showTour &&
        <div className="tourbtn">
        <button onClick={props.onToggleTour} className="btn btn-yellow pulsingButton mt-3">
          {props.tourLabel}
        </button>
        </div>
      }
      <div className={props.secondaryClassName}>
        {
          props.mobile ? (
            <div>
              <h3 className="skills-text mt-1 mb-3 text-center">Recent answers</h3>
              <div className="text-center" id="recent_answers">
                <ul className="list-group headline mb-4" style={{overflow: "auto", maxHeight: "270px"}}>
                  {recent_answers_loop(props.recentAnswers)}
                </ul>
              </div>
            </div>
          ) : (
            <div>
              <h3 className="skills-text mt-1 mb-3 text-center">Recent answers</h3>
              <div className="" id="recent_answers">
                {recent_answers_loop(props.recentAnswers)}
              </div>
              {
                (props.sponsors.length > 0) &&
                <div className={props.secondaryClassName} style={{textAlign:"center"}}>
                  <h3 className="skills-text mt-1 mb-3 text-center">Sponsors</h3>
                  {
                    props.sponsors.map((sponsor, index) => {
                      return(
                        <a key={index} href={sponsor.website} target="_blank" rel="noopener noreferrer">
                          <img src={sponsor.image_url} className="sponsor_img" alt="sponsor_image" />
                        </a>
                      )
                    })
                  }
                </div>
              }
            </div>
          )
        }
      </div>
    </div>
  );
}

function left_panel(skills, complexity, successRate) {
  return(
    <div>

      {
       (skills.length > 0) &&
      <div className="card icon-list mt-4 pt-2 pb-4 d-xl-block d-lg-none d-md-none d-sm-none d-none">
        
          <div>
            <h3 className="skills-text mt-1 text-center">Skills Required</h3>
            <ul className="list-group">
              {
                skills.map((skill, index) => {
                  return(
                    <li key={index} className="list-group-item align-items-center p-0 mt-2"> 
                    <ReactTooltip/>
                      <div className="media">
                        <div className="media-left">
                          <div className="avatar-circle-30px">
                            <span className="initials initials-img">
                              {
                                skill.image &&
                                <img
                                  className="media-object pl-1"
                                  src={skill.image}
                                  alt="skill_image"
                                  data-tip={`${skill.description}`}
                                />
                              }
                            </span>
                          </div>
                        </div>
                        <div className="media-body list-text ml-2 mt-2" >
                          {skill.text}
                        </div>
                      </div>
                    </li>
                  )
                })
              }
            </ul>
          </div>
        
      </div>
      }
      <div className="card icon-list mt-4 pb-5 d-xl-block d-lg-none d-md-none d-sm-none d-none">
        <div className="d-flex analytic-area complexity_area mt-2">
          <h4 className="complexity-text mt-2 mb-3">
          Complexity </h4> <div className="custom-red mt-1 ml-2">
           <img height="55%" width="30%" 
          //  data-tip={complexity} 
           src={`https://attendant-media.s3.ap-southeast-1.amazonaws.com/puzzled/spaces_backup/complexity/${complexity}.gif`}
           alt={complexity}
            />
            </div>
           <span className="text-center">
            <img height="55%" width="30%" src={`https://attendant-media.s3.ap-southeast-1.amazonaws.com/puzzled/spaces_backup/complexity/${complexity}_tooltip.gif`} alt="{complexity}" />
            <h6 className="mt-1 ml-1">{complexity}</h6>
           </span> 

          
          {/* <Progress value="70" color="custom-red" max="100" /> */}

        </div>
        <div className="analytic-area">
          <h4 className="complexity-text">
            {/* Success rate <span className="custom-green ml-2">80/100</span> */}
            Success rate
          </h4>
          <Progress data-tip={`${successRate.users_solved} out of ${successRate.users_attempted} puzzlers solved this level`}  className="custom-green ml-2" value={successRate.rate} color="custom-green" max="100" />
        </div>
      </div>
    </div>
  );
}

class CompletedLevel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      completed_levels: []
    }
  }

  get_completed_levels = async () => {
    let responseJson = await make_request({
      path: "editions/"+this.props.level.edition_id+"/completed_levels/",
      method: 'GET'
    });
    if(responseJson["status"] === "success"){
      this.setState({completed_levels: responseJson['completed_levels']});
    }
  }

  ul_section = () => {
    const {completed_levels} = this.state;
    return(
      <ul className="nav navbar-nav">
        <li className="dropdown mt-2">
          <a
            href="#!"
            className="dropdown-toggle chapter-text"
            data-toggle="dropdown"
            onClick={this.get_completed_levels}>
            Edition {this.props.level.edition_number} - Level {this.props.level.number}
            <i className="fas fa-chevron-down ml-2"></i>
          </a>
          <ul className="dropdown-menu keep-open">
          {
            (completed_levels.length > 0) &&
              <li className="completed_levels_drpdwn">
                <Nav vertical pills>
                  {
                    completed_levels.map((lvl, index) => {
                      return(
                        <NavItem key={index}>
                          <NavLink
                            href={"/edition/"+this.props.level.edition_id+"/"+lvl.name}
                            style={{marginLeft: "10px", marginRight: "10px"}}
                            active={lvl.number === this.props.level.number}>
                            Level {lvl.number}
                          </NavLink>
                        </NavItem>
                      );
                    })
                  }
                </Nav>
              </li>
          }
          </ul>
        </li>
      </ul>
    );
  }

  render() {
    if (this.props.screen === "mobile"){
      return(
        <div className="col-12 align-items-center level_name d-xl-none d-lg-block d-md-block d-sm-block d-block">
          <div className="top-area">
            {this.ul_section()}
          </div>
        </div>
      )
    } else {
      return(
        <div className="col-6 level_name d-xl-block d-lg-none d-md-none d-sm-none d-none">
          <div className="top-area ml-5  align-items-center">
            {this.ul_section()}
          </div>
        </div>
      );
    }
  }
}

class LeaderBoard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_modal_open: false,
      leader_board: {},
    }
  }

  get_leader_board = async () => {
    let responseJson = await make_request({
      path: `leader_board?edition_id=${this.props.editionId}`,
      method: 'GET'
    });
    if(responseJson ){
      this.setState({
        is_modal_open: true,
        leader_board: responseJson.leader_board,
      });
    }
  }

  close_modal = () => {
    this.setState({is_modal_open: false})
  }

  render() {
    return(
      <div>
        <div className={this.props.class_name}>
          <button className="btn Leaderboard btn-yellow" onClick={this.get_leader_board} data-tut={(document.querySelector('#root').offsetWidth > 760) ? "reactour__leader" : ""}>
            Leaderboard
          </button>
        </div>

        <Modal
          isOpen={this.state.is_modal_open}
          toggle={this.close_modal}
          className="left">
          <ModalBody >
            <table className="table user-leader-board table-dark table-hover">
              <tbody>
                {
                  this.state.leader_board && Object.entries(this.state.leader_board).map(([rank,user]) => {
                      return(
                        <tr key={rank} className={user[2] ? "active" : ""}>
                          <td>&nbsp; #{rank}</td>
                          <td><p className="cut-text" title={user[0]}> {user[0]} </p></td>
                          <td>Level {user[1]}</td>
                        </tr>
                      );
                  })
                }
              </tbody>
            </table>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

class LeaderBoard_mobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      is_modal_open: false,
      leader_board: {},
    }
  }

  get_leader_board = async () => {
    let responseJson = await make_request({
      path: `leader_board?edition_id=${this.props.editionId}`,
      method: 'GET'
    });
    if(responseJson ){
      this.setState({
        is_modal_open: true,
        leader_board: responseJson.leader_board,
      });
    }
  }

  close_modal = () => {
    this.setState({is_modal_open: false})
  }

  render() {
    return(
      <div>
        <div className={this.props.class_name}>
          <button
            type="button"
            className="btn btn-yellow"
            onClick={this.get_leader_board}
            data-toggle="collapse"
            data-target="#ldr_brd_mobile"
            data-tut={(document.querySelector('#root').offsetWidth < 760) ? "reactour__leader" : ""}>
            LEADERBOARD
          </button>
                       <div id="ldr_brd_mobile" className="collapse leader_brd_table">
             
                       <table className="table user-leader-board table-dark table-hover">
                        <tbody>
                          {
                            this.state.leader_board && Object.entries(this.state.leader_board).map(([rank,user]) => {
                                return(
                                  <tr key={rank} className={user[2] ? "active" : ""}>
                                    <td>&nbsp; &nbsp; #{rank}</td>
                                    <td>{user[0]}</td>
                                    <td>Level {user[1]}</td>
                                  </tr>
                                );
                            })
                          }
                        </tbody>
                      </table>

                        </div>


        </div>

    
      </div>
    )
  }
}


export {
  clock,
  clock_in_words,
  left_panel,
  RightSidePanel,
  LeaderBoard,
  LeaderBoard_mobile,
  CompletedLevel
};


// import hint_yes from "../../../Assets/img/Group 648.svg";
// import hint_no from "../../../Assets/img/Group 649.svg";

// function HintBar(props) {
//   return(
//     <div className={(props.screen === "mobile") ? "col-11 pt-2 pb-2 mt-3 mb-3 flex-grow-1 d-xl-none d-lg-block d-md-block d-sm-block d-block" : "col-4 pl-3 pt-2 pb-2 pr-0 flex-grow-1 d-xl-block d-lg-none d-md-none d-sm-none d-none"}>
//       <div className={props.secondaryClassName}>
//         {
//           (props.hints.length > 0) &&
//           <Progress multi>
//             <Progress
//               bar
//               color="custom"
//               value={props.progressWidth}
//               max={props.totalTimeInSec}
//             />
//           </Progress>
//         }
//         <div className="progress-icon d-flex">
//           {
//             props.hints.map(([id, hint], inx) => {
//               return (
//                 <span key={id}>
//                   <ReactTooltip id={`hint_${id}`} getContent={[() => props.onHover(hint)]} />
//                   <img
//                     data-tut={(inx === 0) ? "reactour__hints" : ""}
//                     key={id}
//                     src={hint.unlocked ? hint_yes : hint_no}
//                     height="20"
//                     width="20"
//                     alt="hint"
//                     onClick={props.onImageClick(hint)}
//                     // title={props.onHover(hint)}
//                     className="hint-icon"
//                     style={{ left: () => props.hintMargin(hint.time_to_unlock)}}
//                   />
//                 </span>
//               );
//             })
//           }
//         </div>
//       </div>
//     </div>
//   );
// }
